<template>
  <div class="home">
    <img alt="Vue logo" src="/img/labyrinth-logo.jpg">
  </div>
</template>

<script>


export default {
  name: 'Home',
  components: {

  }
}
</script>
